module.exports = __webpack_public_path__ + "img/button_checkout.e4439380.png";